<template>
  <div style="width: 100%;">
    <b-navbar toggleable type="light" variant="" class="lst-order-title">
      <b-navbar-brand>
        <div style="display: flex; align-items: center;">
          <i class="rs-icon-default rs-icon-logo"></i>
          <span style="color: #ced4da; padding-left: 13px;">訂單清單</span>
        </div>
      </b-navbar-brand>
      <b-navbar-toggle target="navbar-toggle-collapse">
        <template #default="{ expanded }">
          <b-icon v-if="expanded" icon="chevron-bar-up" class="rs-icon-title-color"></b-icon>
          <b-icon v-else icon="filter-left" class="rs-icon-title-color"></b-icon>
        </template>
      </b-navbar-toggle>
      <div style="width: 100%;padding: 10px 0px 0px 0px">
        <b-input-group v-if="userType === 'staff'">
          <b-form-input v-model="searchInput" placeholder="輸入客戶名稱、電話或訂單編號搜尋"  v-on:keyup.enter="checkSearchInput()"></b-form-input>
          <b-input-group-append>
            <b-button variant="info" class="rs-button-gl-styl" @click="checkSearchInput">
              <b-icon icon="search"></b-icon>
            </b-button>
          </b-input-group-append>
          <div style="width: 100%; padding: 10px 0px 0px 0px; color: #E9E5E3; font-size: small;">搜尋電話前請先在開頭輸入*</div>
        </b-input-group>
        <b-form-select
          v-model="list_type"
          :options="statusArray"
          class="col-md-12"
          value-field="status"
          text-field="statusString"
          v-if="userType === 'customer'"
        >
          <!-- <template #first>
            <b-form-select-option :value="null">全部訂單</b-form-select-option>
          </template> -->
        </b-form-select>
      </div>
      <b-collapse id="navbar-toggle-collapse" is-nav>
        <div style="width: 100%;padding: 10px 0">
          <b-input-group v-if="userType === 'staff'">
            <b-form-select
              v-model="orderStatus"
              :options="statusArray"
              value-field="status"
              text-field="statusString"
            >
              <!-- <template #first>
                <b-form-select-option :value="null">全部訂單</b-form-select-option>
              </template> -->
            </b-form-select>
            <b-input-group-append>
                <b-form-select
                  v-model="dateOrder"
                  :options="orderArray"
                  value-field="status"
                  text-field="statusString"
                >
                  <template #first>
                    <b-form-select-option :value="null">預設排序</b-form-select-option>
                  </template>
                </b-form-select>
            </b-input-group-append>
          </b-input-group>
          <b-form-select
            v-model="dateOrder"
            :options="orderArray"
            value-field="status"
            text-field="statusString"
            v-if="userType === 'customer'"
          >
            <template #first>
              <b-form-select-option :value="null">預設排序</b-form-select-option>
            </template>
          </b-form-select>
          <b-form-group label="選擇日期區間">
            <b-form-datepicker v-model="dateRangeStart" placeholder="全部日期 (預設)" class="col-md-12"></b-form-datepicker>
          </b-form-group>
          <b-form-group label="到" v-if="dateRangeStart">
            <b-form-datepicker v-model="dateRangeEnd" class="col-md-12"></b-form-datepicker>
          </b-form-group>
        </div>
        <div class="text-right">
          <b-button
            class=""
            size="md"
            @click="initFilter">
            恢復預設
          </b-button>
          <b-button
            class="re-order-filter-submit-sty"
            size="md"
            @click="checkFilterInfo">
            送出條件
          </b-button>
        </div>
      </b-collapse>
    </b-navbar>
    <div class="order-list-contain-sty">
      <div class="col-md-12" style="height: 100vh;display: flex;justify-content: center;align-items: center;" v-if="orderLoading">
        <b-spinner style="width: 10em; height: 10rem;" label="Large Spinner" type="grow"></b-spinner>
      </div>
      <div v-else>
          <div class="" v-if="order_data_array.length > 0">
            <div class="lst-order-sty" v-for="(order, index) in order_data_array" :key="index" :class="{active: order.today}" v-on:click="checkOrderType(index)">
              <div class="list-order-id-sty">
                <span class="order-id-sty"># {{ order.id }} </span>
                <span class="list-order-date-sty" style="margin-left: 10px;">{{order.roc_date}} ( {{order.diplayWeekDay}} )</span>
                <span class="list-order-time-sty">{{order.time_desc }}</span>
              </div>
              <hr>
              <div class="list-order-maincontent-sty">
                <div  v-if="userType === 'staff'"><b class="rs-order-name-sty" v-on:click.stop.prevent="goToAccountPage('customer', order.user_id)">{{ order.name }}</b></div>
                <div  v-if="userType === 'staff'">{{ order.phone }}</div>
                <div class="list-order-location-sty">{{ order.location }}</div>
                <div :class="`list-order-status-sty ${ order.statusClass }`">{{ order.status }}</div>
                <div  v-if="order.staffs && order.staffs.length > 0">
                  <b v-for="(staff, sindex) in order.staffs" :key="sindex">
                    <span v-on:click.stop.prevent="goToAccountPage('staff', staff.id)" v-if='sindex > 0'> , {{ staff.displayN }}</span>
                    <span v-on:click.stop.prevent="goToAccountPage('staff', staff.id)" v-else>{{ staff.displayN }}</span>
                  </b>
                </div>
              </div>
              <hr>
            </div>
            <div class=""  v-if="totals > per">
              <b-pagination
                v-model="page"
                :total-rows="totals"
                :per-page="per"
                first-text="|<<"
                prev-text="<"
                next-text=">"
                last-text=">>|"
                align="center"
                class="rs-order-pages-sty"
              ></b-pagination>
            </div>
          </div>
          <div v-else>
            <div class="row">
              <!-- no orders -->
            </div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'OrderList',
  props: {
    userId: String,
    userType: String
  },
  inject: ['reload'],
  data () {
    return {
      statusArray: [{
        status: null,
        statusString: '近七日訂單(預設)'
      }, {
        status: 5,
        statusString: '全部訂單'
      }, {
        status: 4,
        statusString: '已配對訂單'
      }, {
        status: 2,
        statusString: '已完成訂單'
      }, {
        status: 3,
        statusString: '已取消訂單'
      }],
      orderArray: [{
        status: 'desc',
        statusString: '日期新到舊'
      }, {
        status: 'asc',
        statusString: '日期舊到新'
      }],
      order_data_array: [],
      list_type: null,
      // filter
      orderStatus: null,
      dateOrder: null,
      searchInput: null,
      dateRangeStart: null,
      dateRangeEnd: null,
      page: 1,
      per: 10,
      totals: 0,
      triggerByDate: false,
      orderLoading: false
    }
  },
  created () {
    this.$nextTick(() => {
      this.getOrdersList()
    })
  },
  computed: {
  },
  watch: {
    list_type (val) {
      const currentDate = this.$tool.getDateFormYYYYMMDD()
      const nextDay = this.$tool.getAfterNDaysFromYYYYMMDD(null, 7)
      if (this.triggerByDate) {
        this.triggerByDate = false
      } else {
        if (val === null) {
          this.dateRangeStart = currentDate
          this.dateRangeEnd = nextDay
        } else {
          if (this.dateRangeStart === currentDate && this.dateRangeEnd === nextDay) {
            this.dateRangeStart = null
            this.dateRangeEnd = null
          }
        }
        this.getOrdersList()
      }
    },
    orderStatus (val) {
      switch (val) {
        case 0:
        case 5:
        case 4:
        case 3:
        case 2:
          this.dateRangeStart = null
          this.dateRangeEnd = null
          if (val === 5 || val === 0) {
            this.dateOrder = 'desc'
          }
          break
        case null:
          this.dateRangeStart = this.$tool.getDateFormYYYYMMDD()
          this.dateRangeEnd = this.$tool.getAfterNDaysFromYYYYMMDD(null, 7)
          break
      }
    },
    dateRangeStart (val) {
      const currentDate = this.$tool.getDateFormYYYYMMDD()
      if (val !== currentDate && this.list_type === null) {
        this.triggerByDate = true
        this.list_type = 5
      }
      if (val !== currentDate && this.orderStatus === null) {
        this.orderStatus = 5
      }
    },
    dateRangeEnd (val) {
      const nextDay = this.$tool.getAfterNDaysFromYYYYMMDD(null, 7)
      if (val !== nextDay && this.list_type === null) {
        this.triggerByDate = true
        this.list_type = 0
      }
      if (val !== nextDay && this.orderStatus === null) {
        this.orderStatus = 0
      }
    },
    page () {
      this.orderLoading = true
      this.getOrdersList()
    }
  },
  methods: {
    arrangeOrderData (array) {
      const self = this
      array.forEach((item) => {
        item = self.$toolDoc.arrangeOrderData(item)
      })
      return array
    },
    getOrdersList () {
      const self = this
      const baseUrl = this.$props.userType !== 'staff' ? this.$apiDoc.customerUrl : this.$apiDoc.staffUrl
      const getUrl = baseUrl + this.userId + this.$apiDoc.apiGetOrder
      const currentDate = this.$tool.getDateFormYYYYMMDD()
      const nextDay = this.$tool.getAfterNDaysFromYYYYMMDD(null, 7)
      var options = {
        page: this.page,
        per: this.per
      }
      var errorMsg = this.$toolDoc.defaultErrorMsg
      var logMsg
      var currentTimeArray = []
      var otherArray = []
      if (!this.orderLoading) {
        this.orderLoading = true
      }
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })

      if (this.$props.userType === 'customer') {
        if (this.list_type) {
          options.cond_status = this.list_type
        } else {
          if (this.list_type === null) {
            this.dateRangeStart = currentDate
            this.dateRangeEnd = nextDay
            options.cond_status = 5
            options.date_order = 'asc'
          }
          if (!this.dateOrder && this.list_type === 5) {
            options.date_order = 'desc'
          }
        }
      }

      if (this.$props.userType === 'staff') {
        if (this.orderStatus) {
          options.cond_status = this.orderStatus
        } else {
          if (this.orderStatus === null) {
            this.dateRangeStart = currentDate
            this.dateRangeEnd = nextDay
            options.cond_status = 5
            options.date_order = 'asc'
          }
          if (!this.dateOrder && this.orderStatus === 5) {
            options.date_order = 'desc'
          }
        }
      }
      if (this.dateRangeStart) {
        options.date_range_start = this.dateRangeStart
      }
      if (this.dateRangeEnd) {
        options.date_range_end = this.dateRangeEnd
      }
      if (this.dateOrder) {
        options.date_order = this.dateOrder
      }
      if (this.searchInput || this.searchInput === '0') {
        options.info_like = this.searchInput
      }
      this.$api.get(getUrl, options).then((resp) => {
        if (resp.result) {
          if (resp.data.current_time_list && Array.isArray(resp.data.current_time_list)) {
            currentTimeArray = self.arrangeOrderData(resp.data.current_time_list)
          }
          if (resp.data.list && Array.isArray(resp.data.list)) {
            otherArray = self.arrangeOrderData(resp.data.list)
          }
          self.order_data_array = currentTimeArray.concat(otherArray)
          self.totals = resp.data.total_count
        } else {
          if (resp.data) {
            errorMsg = resp.data
          }
          alert(errorMsg)
        }
        self.orderLoading = false
      }).catch((errorInfo) => {
        logMsg = errorInfo
        console.warn(logMsg)
        alert(errorMsg + JSON.stringify(errorInfo.response))
        self.orderLoading = false
      })
    },
    checkOrderType (fileindex) {
      var currentData
      const errorMsg = this.$toolDoc.defaultErrorMsg
      currentData = this.order_data_array[fileindex]
      if (currentData !== undefined && currentData !== null) {
        this.goToCurrentOrder(currentData.id)
      } else {
        alert(errorMsg)
      }
    },
    goToCurrentOrder (orderId) {
      var routePt = '/' + this.$props.userType + this.$apiDoc.routerOrderInfo + '#' + orderId
      this.$router.push({ path: routePt, replace: true })
      // this.$router.go()
      location.reload()
    },
    checkSearchInput () {
      if (this.searchInput) {
        if (this.orderStatus === null) {
          this.dateRangeStart = null
          this.dateRangeEnd = null
          this.orderStatus = 5
        }
        this.getOrdersList()
      }
    },
    initFilter () {
      this.orderStatus = null
      this.dateOrder = null
      this.searchInput = null
      this.dateRangeStart = null
      this.dateRangeEnd = null
    },
    checkFilterInfo () {
      if (this.orderStatus || this.dateOrder || this.dateRangeStart || this.dateRangeEnd) {
        this.getOrdersList()
      }
    },
    goToAccountPage (accountType, id) {
      var isCorrect = false
      var routePt = '/' + this.$props.userType + this.$apiDoc.routerAccount
      if (accountType && accountType !== 'staff') {
        if (id !== undefined && id !== null && !(this.$props.userType === 'staff' && accountType === 'staff')) {
          isCorrect = true
        }
      }
      if (isCorrect) {
        routePt += accountType
        routePt += '#' + id
        this.$router.push({ path: routePt, replace: true })
        location.reload()
      }
    }
  },
  component: {
  }
}
</script>
